import React, {useState} from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";


const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;

    .content {
      width: 100%;
      padding: 15px 10px;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: var(--color-light);
      .row {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: center;
        justify-content: center;
        height: auto;
        gap: 15px;
        .col {
          text-align: center;
          display: flex;
          flex-direction: column;
          gap: 10px;
          align-items: center;
          .title{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-lg);
            border-bottom: 1px solid;
            text-align: center;
            border-color: ${({ theme }) => theme.mainBorderColor};
          }
          .text{
            font-size: var(--font-size-xs);
            font-weight: var(--font-weight-sm);
          }
          span{
            color: var(--color-main);
            border: 1px solid var(--color-main);
            width: 100px;
            border-radius: 5px;
            padding: 5px;
          }
        }
      }
    }
  }
  .btn{
    flex-direction: row !important;
    justify-content: center;
  }
  @media (max-width: 600px){
    .row{
      grid-template-columns: 1fr !important;
    }
  }
`;

const IsOrtaklariMobileContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const {topBarCompanyInfo} = useSelector((state)=> state.companyProfile)
  const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;

  const userId = JSON.parse(storage.getItem("userId"))
  
  const dispatch = useDispatch();
  
  return (
    <Container theme={theme}>
      <div className="container">
        <div className="content">
          <div className="row">
            <div className="col">
                <p className="title">Proje Adı</p>
                <p className="text">{data?.projectName}</p>
            </div>
            <div className="col">
                <p className="title">Dijital Lojistikçi / Nakliyeci / Kooperatif</p>
                <p className="text">{data?.digitalLogisticCompanyName}</p>
            </div>
            <div className="col">
                <p className="title">Görmesi İstenen Yükveren Müşteri</p>
                <p className="text">
                  {data?.loadOwnerCompanyDtos?.map((item) => (
                    <div className="companies">{item?.loadOwnerCompanyName}</div> 
                  ))}
                </p>
            </div>
            {/* {(data?.createUserId === userId && data?.isApproved === false) && <div className="col">
                <p className="title">Durum</p> 
                <p className="text">Onay Bekliyor</p></div> 
            }
            {(data?.createUserId !== userId && data?.isApproved === false) && 
              <div className="col btn"> 
                <p className="title">Durum</p>
                <span onClick={() => dispatch(companiesProjectApprove({id: data?.id, isApproved: true}))} >Onayla</span> 
                <span onClick={() => dispatch(companiesProjectApprove({id: data?.id, isApproved: false}))} >Reddet</span> 
              </div>
            }
            {data?.isApproved === true && <div className="col">
                <p className="title">Durum</p>
                <p className="text">Onaylandı</p>
            </div> } */}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default IsOrtaklariMobileContainer;
